import script from "./UserVerify.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserVerify.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__